import { useMemo } from 'react';
import SwipeRow from './SwipeRow';
import { BDListRow } from './BDCard';

const T = { orange:'var(--orange)', ink:'var(--ink)', muted:'var(--muted)', green:'#16A34A' };
const FONT = "'Inter',-apple-system,sans-serif";

export default function ToReadView({ bds, onOpenDetail, onEdit, onDelete, onToggleLu }) {
  const groups = useMemo(() => {
    const unread = bds.filter(b => !b.lu);
    const bySerie = {};
    unread.forEach(b => {
      const k = b.serie?.trim() || 'Sans série';
      (bySerie[k] = bySerie[k] || []).push(b);
    });
    Object.values(bySerie).forEach(list => list.sort((a,b)=>(parseInt(a.numero)||0)-(parseInt(b.numero)||0)));
    return Object.entries(bySerie).sort((a,b)=>a[0].localeCompare(b[0],'fr'));
  }, [bds]);

  const total = groups.reduce((n,[,list])=>n+list.length, 0);

  if (!total) return (
    <div style={{ textAlign:'center', padding:'3rem 1rem' }}>
      <div style={{ fontSize:'2.4rem', marginBottom:'10px' }}>🎉</div>
      <div style={{ fontSize:'15px', fontWeight:700, color:T.ink, fontFamily:FONT, marginBottom:'4px' }}>Tout est lu !</div>
      <div style={{ fontSize:'13px', color:T.muted, fontFamily:FONT }}>Aucun album en attente de lecture.</div>
    </div>
  );

  return (
    <div style={{ fontFamily:FONT }}>
      <div style={{ fontSize:'13px', fontWeight:600, color:T.muted, marginBottom:'14px' }}>
        📖 {total} album{total>1?'s':''} à lire — glisse une ligne vers la droite pour la marquer comme lue
      </div>

      {groups.map(([serie, list]) => (
        <div key={serie} style={{ marginBottom:'18px' }}>
          <div style={{ fontSize:'11px', fontWeight:700, color:T.orange, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'6px' }}>
            {serie} <span style={{ color:T.muted, fontWeight:600 }}>· {list.length}</span>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'8px' }}>
            {list.map(bd => (
              <SwipeRow key={bd.id}
                onOpen={origin=>onOpenDetail(bd, origin)}
                leftAction={{ icon:'✓', label:'Lu', color:T.green, onClick:()=>onToggleLu(bd) }}
                rightActions={[
                  { icon:'✏️', label:'Éditer', color:'#3B6FBF', onClick:()=>onEdit(bd) },
                  { icon:'🗑️', label:'Suppr.', color:'#DC2626', onClick:()=>onDelete(bd) },
                ]}>
                <BDListRow bd={bd} onDelete={()=>onDelete(bd)}/>
              </SwipeRow>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
